import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import store from 'store'
import {addItemToBox, closeBox, getBoxDetail, getListBoxItems} from "../../../services/api/apiNextBox"
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import NextBoxFBADetail from "./NextBoxFBADetail";
import { getRoles } from '../../../services/AuthServices'
import parseIncompleteOrders from "../helpers/parseIncompleteOrders"
import { Alert } from 'antd'


class NextBoxFBAPage extends Component {
    state = {
        loadingFBA: false,
        errorFBA: '',
        // Lỗi riêng của items API. Không dùng chung errorFBA vì 2 fetch chạy song song:
        // _fetchBoxDetailFBA khi thành công set errorFBA = '' và sẽ xoá mất thông báo này.
        errorItemsFBA: '',
        // false = chưa biết thùng có đơn nào chưa đóng đủ hay không
        loadedItemsFBA: false,
        barcodeErrorFBA: store.get('barcodeErrorFBA') || [],
        itemsFBA: [],
        incompleteOrdersFBA: [],
        boxFBA: null,
    }

    componentDidMount() {
        this._fetchBoxDetailFBA()
        this._fetchListBoxItemsFBA()
    }

    _fetchListBoxItemsFBA = async () => {
        try {
            const {success, data, message} = await getListBoxItems(this.props.boxId)

            if (!success) {
                throw new Error(message)
            }

            const {items, possibly_incomplete_orders} = Object.assign({}, data)

            return this.setState({
                itemsFBA: Array.isArray(items) ? items : [],
                incompleteOrdersFBA: parseIncompleteOrders(possibly_incomplete_orders),
                errorItemsFBA: '',
                loadedItemsFBA: true,
            })
        } catch (e) {
            this.setState({
                errorItemsFBA: e.message || e,
                // Không giữ lại dữ liệu cũ: nếu giữ, nút "Đóng thùng" có thể bị khoá
                // vĩnh viễn theo dữ liệu đã lỗi thời mà trang không còn cách làm mới
                incompleteOrdersFBA: [],
                // Vẫn đánh dấu đã xong để không chặn nút vĩnh viễn (fail-open),
                // nhưng lỗi được hiển thị ra UI ở render() bên dưới
                loadedItemsFBA: true,
            })
        }
    }

    _fetchBoxDetailFBA = async () => {
        if (this.state.loadingFBA) return true

        this.setState({
            loadingFBA: true,
            errorFBA: ''
        })

        try {
            const {success, data, message} = await getBoxDetail(this.props.boxId)

            if (!success) {
                throw new Error(message)
            }

            return this.setState({
                boxFBA: data,
                loadingFBA: false,
                errorFBA: ''
            })
        } catch (e) {
            this.setState({
                loadingFBA: false,
                errorFBA: e.message || e,
                boxFBA: null,
            })
        }
    }

    _pushNewItemFBA = (newItems) => {
        if (!newItems || !newItems.length) return false

        const {itemsFBA} = this.state
        const vItems = newItems.filter(newItem => {
            const {item_number, item_index} = newItem
            const existing = itemsFBA.find(item => {
                return item && item.item_number === item_number && item.item_index === item_index
            })

            return !existing
        })

        if (!vItems.length) return true

        this.setState({
            itemsFBA: [].concat(vItems, itemsFBA)
        }, () => {
            const {id} = Object.assign({}, this.state.boxFBA)

            return Promise.all(vItems.map(newItem => {
                const {item_number} = newItem

                return pushNewItemHistory(`${item_number}_1`, {
                    event_key: 'scan_to_package',
                    event_description: 'Scan QR to package.',
                    event_meta: {
                        box_number: id,
                    }
                })
            }))
        })

        return true
    }

    _handleSubmitFBA = async (barcode) => {
        const vBarcode = (barcode ? barcode.trim() : '').replace(/#/gi, '')

        if (!vBarcode) {
            throw new Error('Barcode is invalid.')
        }

        const {success, data, message} = await addItemToBox(this.props.boxId, vBarcode)

        if (!success) {
            throw new Error(message)
        }

        await this._fetchBoxDetailFBA()

        return this._pushNewItemFBA(data)
    }

    _handleOnCloseFBA = async (payload) => {
        try {
            const {success, message} = await closeBox(this.props.boxId, payload)

            if (!success) {
                throw new Error(message)
            }

            await this._fetchBoxDetailFBA()

            this.setState({
                barcodeErrorFBA: []
            }, store.remove('barcodeErrorFBA'))

            return this.props.reloadClosedBox(this.state.boxFBA.closed_at)
        } catch (e) {
            window.alert('Lỗi: ' + e.message)
        }
    }

    _handleUpdateLocalStoreFBA = (box_id, error) => {
        const barcodeErrorFBA = store.get('barcodeErrorFBA') || []
        const boxExits = barcodeErrorFBA.find(item => item.boxID === box_id)
        let newBarcodes = []

        if (boxExits !== undefined) {
            newBarcodes = barcodeErrorFBA.map(item => {
                if (item.boxID === box_id) {
                    return {
                        boxID: box_id,
                        barcodes: item.barcodes.concat(error)
                    }
                } else {
                    return item
                }
            })
        } else {
            newBarcodes = barcodeErrorFBA.map(item => item)
            newBarcodes.push({
                boxID: box_id,
                barcodes: error
            })
        }

        this.setState({
            barcodeErrorFBA: newBarcodes
        }, () => {
            store.set('barcodeErrorFBA', newBarcodes)
        })
    }

    _handleOnRefreshFBA = async () => {
        await Promise.all([
            this._fetchBoxDetailFBA(),
            this._fetchListBoxItemsFBA(),
        ])
    }

    render() {
        const {isPrivate} = this.props
        const {indexBoxClosed} = this.props
        const {loadingFBA, boxFBA, itemsFBA, barcodeErrorFBA, incompleteOrdersFBA, errorFBA, errorItemsFBA, loadedItemsFBA} = this.state

        const Roles = getRoles()
        const listRole = Roles && Roles.length > 0 ? Roles.map(i=>i.name) : []
        const isAdmin = listRole.includes('fac_admin')

        return (
            <div className={classNames("NextBoxPage", {loadingFBA})}>
                {!!errorFBA && <div className="text-danger mb-2">{errorFBA}</div>}

                {!!errorItemsFBA &&
                    <Alert
                        className="mb-3"
                        type="error"
                        showIcon
                        message="Không tải được danh sách đơn chưa đóng đủ"
                        description={`${errorItemsFBA} — cảnh báo đơn thiếu đang không khả dụng và nút "Đóng thùng" vẫn mở. Hãy tải lại trang trước khi đóng thùng.`}
                    />
                }

                {
                    !!boxFBA && <NextBoxFBADetail
                        loading={loadingFBA}
                        isPrivate={isPrivate}
                        isAdmin={isAdmin}
                        barcodeError={barcodeErrorFBA}
                        box={boxFBA}
                        items={itemsFBA}
                        incompleteOrders={incompleteOrdersFBA}
                        incompleteOrdersLoaded={loadedItemsFBA}
                        indexBoxClosed={indexBoxClosed}
                        onUpdateLocalStore={this._handleUpdateLocalStoreFBA}
                        onClose={this._handleOnCloseFBA}
                        onRefresh={this._handleOnRefreshFBA}
                    />
                }
            </div>
        )
    }
}

NextBoxFBAPage.propTypes = {
    isPrivate: PropTypes.bool.isRequired,
    boxId: PropTypes.string.isRequired,
    indexBoxClosed: PropTypes.number
}

export default NextBoxFBAPage
